// Sondage: the survey in progress and the sending of the answers.
// No backend yet: the survey is the sample of the prototype (jawdaplus-prototype-v5-fr.html) and the
// answers are not sent. Only this file changes when the endpoints arrive.
// Question types: qcs (one answer), qcm (several, max 0 = no limit), yn (yes / no), text (free answer).

export const SAMPLE_SURVEY = {
  status: "live",
  start: "2026-10-15",
  end: "2026-11-25",
  tombola: true,
  draw: "2026-11-30",
  prize: { fr: "Des paniers de produits à gagner chaque mois", ar: "سلال منتجات للربح كل شهر" },
  title: { fr: "Votre avis sur nos produits", ar: "رأيك في منتجاتنا" },
  desc: { fr: "Quelques questions rapides pour mieux vous servir.", ar: "بعض الأسئلة السريعة لخدمتك بشكل أفضل." },
  questions: [
    {
      type: "qcs",
      req: true,
      q: { fr: "À quelle fréquence achetez-vous nos produits ?", ar: "كم مرة تشتري منتجاتنا؟" },
      opts: [
        { fr: "Chaque semaine", ar: "كل أسبوع" },
        { fr: "Chaque mois", ar: "كل شهر" },
        { fr: "Rarement", ar: "نادرا" },
        { fr: "C'est la première fois", ar: "هذه أول مرة" },
      ],
    },
    {
      type: "qcm",
      req: true,
      max: 0,
      q: { fr: "Où les achetez-vous ?", ar: "أين تشتريها؟" },
      opts: [
        { fr: "Supérette", ar: "سوبيرات" },
        { fr: "Épicerie de quartier", ar: "بقالة الحي" },
        { fr: "Grande surface", ar: "مركز تجاري" },
        { fr: "En ligne", ar: "عبر الإنترنت" },
      ],
    },
    {
      type: "yn",
      req: true,
      q: { fr: "Avez-vous goûté notre nouveau format 1,5 L ?", ar: "هل جربت حجمنا الجديد 1,5 لتر؟" },
    },
    {
      type: "qcs",
      req: true,
      q: { fr: "Qu'est-ce qui compte le plus pour vous ?", ar: "ما هو الأهم بالنسبة لك؟" },
      opts: [
        { fr: "Le goût", ar: "الذوق" },
        { fr: "Le prix", ar: "السعر" },
        { fr: "La disponibilité", ar: "التوفر" },
        { fr: "L'emballage", ar: "التغليف" },
      ],
    },
    {
      type: "text",
      req: false,
      q: { fr: "Quel produit aimeriez-vous trouver chez nous ?", ar: "ما المنتج الذي تود أن تجده عندنا؟" },
    },
  ],
};

// the survey shown on the home page and on /sondage; null when none is in progress
export const loadSurvey = async () => {
  const survey = SAMPLE_SURVEY;
  return survey.status === "live" && survey.questions.length > 0 ? survey : null;
};

// answers: one per question (option index, list of indexes, "yes" / "no", text or null when skipped).
// Returns the participation number when a phone is given (prototype: TB- and 6 digits).
export const sendSurvey = async ({ answers, phone }) => {
  await new Promise((resolve) => setTimeout(resolve, 600));
  return { ticket: phone ? `TB-${Math.floor(100000 + Math.random() * 900000)}` : null };
};

// a survey text in the page language; without one, the French (prototype)
export const surveyText = (value, lang) => (value && (value[lang] || value.fr)) || "";

// about 15 seconds a question
export const surveyMinutes = (count) => Math.max(1, Math.round((count * 15) / 60));

const MONTHS = {
  fr: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
  ar: ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
};

// "2026-11-30" -> "30 novembre 2026"
export const surveyDate = (iso, lang) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  return m ? `${+m[3]} ${(MONTHS[lang] || MONTHS.fr)[+m[2] - 1]} ${m[1]}` : "";
};
